import { Locale } from "core/i18n/i18n";

export const languageKey = 'language';
export const getLanguage = () => {
  return window.localStorage.getItem(languageKey) ?? Locale.EN;
};